import '.ap{flex-shrink:0;}.ssr-plugin'
import '.iy{line-height:1.4;}.ssr-plugin'
import '.b1{text-align:center;}.ssr-plugin'
import '.bb{font-size:0.875rem;}.ssr-plugin'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled, type Style } from 'inlines'

export type SkeletonProps = {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  error?: boolean
  errorMessage?: string
  style?: Style
}

const shimmerStyle: Style = {
  background:
    'linear-gradient(90deg, var(--palette-blue-50) 25%, var(--gray-50) 50%, var(--palette-blue-50) 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.6s linear infinite',
}

const errorStyle: Style = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.375rem',
  padding: '0.5rem',
  overflow: 'hidden',
  background: 'var(--gray-100)',
  color: 'var(--gray-700)',
}

export const Skeleton = ({
  width = '100%',
  height = '1rem',
  borderRadius = '0.25rem',
  error = false,
  errorMessage = 'Failed to load',
  style,
}: SkeletonProps) => (
  <styled.div className="ap"
    style={{
      width,
      height,
      borderRadius,
      ...(error ? errorStyle : shimmerStyle),
      ...style,
    }}
  >
    {error && (
      <>
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          style={{ width: '1.5rem', height: '1.5rem' }}
        />
        {errorMessage && (
          <span className="iy b1 bb"
          >
            {errorMessage}
          </span>
        )}
      </>
    )}
  </styled.div>
)
